<div class="modal-header">
  <h4 class="modal-title">
    {{ getTranslationKey('HEADER') | translate }}
  </h4>
</div>
<div class="modal-body">
  {{ getTranslationKey('INFO') | translate }}
  <br />
  <strong>{{ getTranslationKey('ASK_FOR_REDIRECT') | translate }}</strong>
</div>
<div class="modal-footer">
  <button type="button" class="btn btn-light" (click)="cancel()">
    {{ getTranslationKey('NO') | translate }}
  </button>
  <button type="button" class="btn btn-primary" (click)="redirect()">
    {{ getTranslationKey('YES') | translate }}
  </button>
</div>
